import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { BreadcrumbJsonLd } from 'next-seo';
import { useTranslations } from 'next-intl';

const {
  publicRuntimeConfig: { appBaseUrl },
} = getConfig();

const FILTERED_QUERY_PARAMS = ['trackingId', 'funnel'];

const BreadcrumbList = ({ name }) => {
  const router = useRouter();
  const tGlobal = useTranslations('Global');

  const regex = new RegExp(
    `\\??(${FILTERED_QUERY_PARAMS.join('||')})=([^&]*)`,
    'g',
  );
  const canonicalUrl = `${appBaseUrl}${router.asPath.replace(regex, '')}`;

  return router?.asPath ? (
    <BreadcrumbJsonLd
      itemListElements={[
        { position: 1, item: appBaseUrl, name: tGlobal('companyName') },
        { position: 2, item: canonicalUrl, name },
      ]}
    />
  ) : null;
};

export default BreadcrumbList;
